import * as React from "react";

import "./password-input.scss";

import {cs} from "../../react/chain-services";
import {UseState} from "../../react/use-state";
import {FontAwesomeIcon} from "../../../xpresso/node_modules/@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from '../../../xpresso/node_modules/@fortawesome/free-solid-svg-icons';

export const PasswordInput = ({inputProps = null}:{
    inputProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLInputElement>, HTMLInputElement> & {[key:string]: any}
}={}) => cs(
    ["showPassword", (_, next) => UseState({next, initValue: false})],
    ({showPassword}) => ( 
        <div className="password-input-j7s password-input">
            <input 
                {...inputProps}
                type={showPassword.value ? "text" : "password"}
                xd-qa-type= "textbox"
            />
            <div className="input-control">
                <div
                    className="show-hide"
                    onClick={() => showPassword.onChange(!showPassword.value)}
                >
                    {inputProps.readOnly == undefined ? (
                        <FontAwesomeIcon className={"icon"} icon={showPassword.value ? faEyeSlash : faEye} xd-qa-type="icon" xd-qa-name={showPassword.value ? "hide" : "show"}/>
                    ) : (
                        !inputProps.readOnly && <FontAwesomeIcon className={"icon"} icon={showPassword.value ? faEyeSlash : faEye} xd-qa-type="icon" xd-qa-name={showPassword.value ? "hide" : "show"}/>
                    )}
                </div>
            </div>
        </div>
    )
);
